import alibaba from './alibaba.json';

import ecs from './ecs.json';
import csg from './csg.json';
import loadbalancer from './loadbalancer.json';
import oss from './oss.json';
import sql from './sql.json';
import waf from './waf.json';

export default [alibaba, ecs, csg, loadbalancer, oss, sql, waf];
